module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("dMSnQ"))).then(() => parcelRequire('hEqeo'));